<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>Stations</h1>
        <span class="text-sm text-gray-500">{{ stationCount() }} stations · {{ areaCount() }} areas</span>
      </div>
    </div>

    <p-panel header="Search">
      <div class="flex flex-wrap items-center gap-4">
        <p-iconfield class="w-full md:w-80">
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" [formControl]="searchFilter" placeholder="Search station ID or name" aria-label="Search stations" class="w-full" />
        </p-iconfield>
        <p-multiselect
          [options]="areaOptions()"
          [formControl]="areaFilter"
          optionLabel="label"
          optionValue="value"
          placeholder="All areas"
          ariaLabel="Filter by area"
          [showClear]="true"
          class="w-full md:w-80"
        />
      </div>
    </p-panel>

    @for (group of areaGroups(); track group.area) {
      <section class="area-section">
        <div class="area-section__header">
          <h2>{{ group.area }}</h2>
          <p-tag [value]="group.stations.length + (group.stations.length === 1 ? ' station' : ' stations')" severity="secondary" />
        </div>
        <!-- Station tiles are already cards: grid goes straight in the section -->
        <div class="grid-auto-3">
          @for (station of group.stations; track station.id) {
            <p-panel class="cursor-pointer" [header]="station.assetId" (click)="redirectToWeightStation(station.assetId)">
              <p-card>
                @if (station.name) {
                  <ng-template pTemplate="title" class="text-base font-medium text-gray-800">{{ station.name }}</ng-template>
                }
                @if (station.assetTypeName) {
                  <ng-template pTemplate="subtitle" class="text-sm text-gray-500 mt-1">{{ station.assetTypeName }}</ng-template>
                }
              </p-card>
            </p-panel>
          }
        </div>
      </section>
    } @empty {
      @if (isLoading() === 0) {
        <p class="text-gray-500">No stations match the current filters.</p>
      }
    }
  </div>
</main>
